import React from "react";

const FullLoading = ({
  loading,
  backgroundColor = "rgba(255, 255, 255, 0.8)",
}: {
  loading: boolean;
  backgroundColor?: string;
}) => {
  return (
    <>
      {loading && (
        <div
        // className="position-relative"
        // style={{ height: "100vh", width: "100vw" }}
        >
          <div
            className="loading-spinner-overlay full-loading-overlay"
            style={{ backgroundColor }}
          >
            <div className="loading-spinner"></div>
          </div>
        </div>
      )}
    </>
  );
};

export default FullLoading;
